import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

interface PaymentProviderBadgeProps {
  provider: string;
  label: string;
  className?: string;
}

export function PaymentProviderBadge({ provider, label, className }: PaymentProviderBadgeProps) {
  const { t } = useTranslation();
  const display = t(`payments.providers.${provider}`, { defaultValue: label });

  const tone =
    provider === 'myfatoorah'
      ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300'
      : provider === 'instapay'
        ? 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300'
        : provider === 'custom_gateway'
          ? 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-300'
          : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        tone,
        className,
      )}
    >
      {display}
    </span>
  );
}
